import {Component, Input, OnInit, OnDestroy} from '@angular/core';
import {DashboardService} from "../../../dashboard/services/dashboard.service";
import {Utils} from "../../Utils";
import { NouiFormatter} from "ng2-nouislider";

declare var $: any;
declare var noUiSlider;
@Component({
  selector: 'app-map-daily-animation',
  templateUrl: './map-daily-animation.component.html',
  styleUrls: ['./map-daily-animation.component.less']
})
export class MapDailyAnimationComponent implements OnInit, OnDestroy {

  _map:any;
  subscription:any;
  data:any;
  mappedData:any;
  lastDataDate:any;
  currentDate:Date;
  dataCount:number = 13;
  @Input() mapId;
  @Input() mapTitle;
  currentIteration: number = 13;
  currentDateString:string;
  currentDateDateKey:string;
  disabled:boolean = true;
  highestData: number = -Infinity;
  lowestData: number = Infinity;
  numberOfLegendCategories: any;
  increment: number;
  heatMapColors = [
  {color : '#003c56', label : "", lower: '', upper: '', topLabel: "  "},
  {color : '#006997', label : "", lower: '', upper: '' },
  {color : '#0096d7', label : "", lower: '', upper: '' },
  {color : '#4db6e3', label : "", lower: '', upper: '' },
  {color : '#99d5ef', label : "", lower: '', upper: '' },
  {color : '#e5c799', label : "", lower: '', upper: '' },
  {color : '#d19d69', label : "", lower: '', upper: '' },
  {color : '#bd732a', label : "", lower: '', upper: '' },
  {color : '#84511d', label : "", lower: '', upper: '' },
  {color : '#4c2e11', label : "", lower: '', upper: '', topLabel: "degrees Fahrenheit" }
  ];
  incrementsArray: any = [];

  constructor(private dashboardService: DashboardService) { }

  ngOnInit() {

    this.subscription = this.dashboardService.getTemperatureDepartureDailyAnimation().subscribe(
      json => {
        this.data = json;
      }, null, () => {
        let that = this;
        this.numberOfLegendCategories = 10;

        for(let date in this.data.data){

          //get highest and lowest values
          for(let regionData in that.data.data[date].data){
            this.highestData = Math.max(this.highestData, parseInt(this.data.data[date].data[regionData]));
            this.lowestData = Math.min(this.lowestData, parseInt(this.data.data[date].data[regionData]));
          }
        }


        let difference = Math.ceil((that.highestData - that.lowestData) / this.numberOfLegendCategories) * this.numberOfLegendCategories;

        this.increment = Math.round(difference/this.numberOfLegendCategories);// get distance between numbers

        let tempNumber:number = this.lowestData - Math.floor((difference - (that.highestData - that.lowestData)) / 2 );
        this.heatMapColors.forEach(function(elm,index, array) {
          elm.label = tempNumber + '-' + (tempNumber + that.increment - 1);
          elm.lower = tempNumber.toString();
          elm.upper = (tempNumber + that.increment - 1).toString();
          elm.label = elm.lower + '-' + elm.upper;
          tempNumber = tempNumber + that.increment;
          that.incrementsArray.push(tempNumber);
        });


        that.dataCount = 0;

        //put objects in an array so we can sort through them
        for(var prop in that.data.data){
          that.dataCount++;
        }
        this.dataCount--;

        this.currentIteration = this.dataCount;
        this.lastDataDate = Utils.oracleDateStringToDate(this.data.date);
        this.currentDate = new Date(this.lastDataDate);
        this.updateCurrentDate();

        let map = $('#' + this.mapId).vectorMap({
          map: 'climate-divisions_aea_en',
          backgroundColor: '#ffffff',
          series: {
            regions: [{
              values: this.mappedData,
              attribute : 'fill',
              scale: {
                "1":this.heatMapColors[0].color,
                "2":this.heatMapColors[1].color,//"#006997",
                "3":this.heatMapColors[2].color,//"#0096d7",
                "4":this.heatMapColors[3].color,//"#4db6e3",
                "5":this.heatMapColors[4].color,//"#99d5ef",
                "6":this.heatMapColors[5].color,//"#e5c7aa",
                "7":this.heatMapColors[6].color,//"#d19d69",
                "8":this.heatMapColors[7].color,//"#bd732a",
                "9":this.heatMapColors[8].color,//"#84511d",
                "10":this.heatMapColors[9].color//"#4c2e11"
              }
            }]
          },
          onRegionLabelShow: function(e, el, code){
            let currentRegName = el.html().toLowerCase().split(",");
            let stateRegName = currentRegName[1].toUpperCase();
            let cityName = currentRegName[0];

            el.html('<span class="regionTitle">' + cityName + ", " + stateRegName + '</span>' + ' : ' + that.data.data[that.currentDateDateKey].data[code] + ' &#x2109;') // storage region here
          }
        });
        this._map = map.vectorMap('get', 'mapObject');

        // render lines for storage regions
        let storageRegionsPath = document.createElementNS(this._map.canvas.rootElement.node.namespaceURI, "path");
        storageRegionsPath.setAttributeNS(null, 'd', this._map.mapData.storagePath);
        storageRegionsPath.setAttributeNS(null, 'fill', 'none');
        storageRegionsPath.setAttributeNS(null, 'stroke', 'white');
        storageRegionsPath.setAttributeNS(null, 'stroke-width', "5");

        this._map.canvas.rootElement.node.appendChild(storageRegionsPath);
        this.disabled = false;
      });
  }

    public iterateMap(iteration) {
        this.currentIteration = iteration;
        this.updateCurrentDate();
    };

  private updateCurrentDate() {
    let d = new Date(this.lastDataDate.getTime());
    d.setDate(d.getDate() - (this.dataCount - this.currentIteration));
    this.currentDate = d;
    this.currentDateString = Utils.dateAsDDMMMYY(this.currentDate);
    this.currentDateDateKey = Utils.dateAsOracleDateString(this.currentDate);
    this.generateSingleDayData(this.currentDateDateKey);
    if(this._map) {
      this._map.series.regions[0].setValues(this.mappedData);
    }
  }

  private generateSingleDayData(date) {
    this.mappedData = {};
    let singleDayData = this.data.data[date];

    for(let code in singleDayData.data) {
      let temperature:number = +singleDayData.data[code];

      switch (true) {
        case  temperature <= this.incrementsArray[0]:
          this.mappedData[code] =  '1';
          break;
        case temperature <=  this.incrementsArray[1]:
            this.mappedData[code] =  '2';
            break;
        case temperature <=  this.incrementsArray[2]:
            this.mappedData[code] =  '3';
            break;
        case temperature <=  this.incrementsArray[3]:
            this.mappedData[code] =  '4';
            break;
        case temperature <=  this.incrementsArray[4]:
            this.mappedData[code] =  '5';
            break;
        case temperature <=  this.incrementsArray[5]:
            this.mappedData[code] =  '6';
            break;
        case temperature <=  this.incrementsArray[6]:
            this.mappedData[code] =  '7';
            break;
        case temperature <=  this.incrementsArray[7]:
            this.mappedData[code] =  '8';
            break;
        case temperature <=  this.incrementsArray[8]:
            this.mappedData[code] =  '9';
            break;
        default:
          this.mappedData[code] = '10';
      }
    }
  }

  public playDailyAnimation(){
        let that = this;
        // reset to beginning if they hit play when on the last date
        if(this.currentIteration == this.dataCount){
          this.currentIteration = -1;
        }

        // Play Interval
        var interval = setInterval( function(e) {
          that.currentIteration++;
          if(that.currentIteration > that.dataCount) {
            stopInterval();
            return;
          }

          that.updateCurrentDate();
        }, 1000);

        // Stop - Restart Interval
        $('#stopRestart').click(function(){
          clearInterval(interval);
        });

      function stopInterval() {
          clearInterval(interval);
      }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
    if(this._map !== undefined) {
      this._map.remove();
      this._map = undefined;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/share-modules/eia-charts/map-daily-animation/map-daily-animation.component.ts